import { render, staticRenderFns } from "./WoocommerceAdd.vue?vue&type=template&id=6bbcd54b&scoped=true"
import script from "./WoocommerceAdd.vue?vue&type=script&lang=js"
export * from "./WoocommerceAdd.vue?vue&type=script&lang=js"
import style0 from "./WoocommerceAdd.vue?vue&type=style&index=0&id=6bbcd54b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbcd54b",
  null
  
)

export default component.exports